import { connect } from 'react-redux';
import { proceedIdPage } from '../../../services/id';
import PasswordAuthInductionModal from './PasswordAuthInductionModal';

function mapStateToProps({ id, auth }) {
  return {
    firebaseUser: auth.firebaseUser,
    accountIntegrationInductionModal: id.accountIntegrationInductionModal,
    doctorAuthenticationInductionModal: id.doctorAuthenticationInductionModal,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    async proceedIdPage(path) {
      await dispatch(proceedIdPage(path));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PasswordAuthInductionModal);
